import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import { validateForm, validation } from '../../../utils/validation';
import { connect } from 'react-redux';
import { Input, Button, ValidationMessage, Toast } from '../../../component';

class WantFlight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: { maxPrice: [] },
      alertMessage: 'department.departmentadd',
      toastState: 'success',
      showModal: false,
      toast: false,
      maxPrice: '0',
    };
  }

  validate = () => {
    const { maxPrice } = this.state;
    const { error, result } = validateForm({
      maxPrice: validation.number(maxPrice).required().errors,
    });
    return { error, result };
  };

  render() {
    const { toast, alertMessage, toastState, errors, maxPrice } = this.state,
      {
        intl,
        language: { direction },
      } = this.props;
    return (
      <>
        <div className="d-flex w-100 flex-column pt-md-0 pt-2 pb-3 px-0">
          <Toast
            isOpen={toast}
            onClose={() => this.setState({ toast: false })}
            state={toastState}
            position="bottom"
            message={intl.formatMessage({
              id: alertMessage,
            })}
            direction={direction}
          />
          <div className="d-flex col-12 align-items-center">
            <div className="col-6">
              <Input
                name="maxPrice"
                label={intl.formatMessage({
                  id: 'booking.price',
                })}
                type="text"
                inputClassName="d-flex bg-third-light align-items-center font-small "
                themeMode="light"
                outSideLabel={true}
                outSideLabelPosition="top"
                outSideLabelClass="text-start px-3"
                value={
                  !isNaN(maxPrice) &&
                  maxPrice !== 0 &&
                  String(maxPrice).replace(/(.)(?=(\d{3})+$)/g, '$1,')
                }
                onChange={({ target: { value } }) => {
                  this.setState({
                    maxPrice: parseInt(value.replaceAll(',', '')),
                    errors: {
                      maxPrice: validation
                        .number(value.toString()?.replaceAll(',', ''))
                        .required().errors,
                    },
                  });
                }}
              />
              <ValidationMessage errors={errors?.maxPrice} />
            </div>

            <div className="col-6">
              <Button
                name={`insert-wantFlight`}
                id={`insert-wantFlight`}
                onClick={() => {
                  const { result } = this.validate();
                  if (result) {
                    this.setState({
                      alertMessage: 'profile.quotaadd',
                      toast: true,
                      toastState: 'success',
                    });
                    console.log('sabt sjod', this.state.maxPrice);
                  }
                }}
                className="btn-primary text-white"
                label={intl.formatMessage({ id: 'profile.insertinformation' })}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
    user: state?.user?.userInfo ?? [],
  };
}

export default injectIntl(withRouter(connect(mapStateToProps)(WantFlight)));
